import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { CheckCircle, Loader } from 'lucide-react';
import { api } from '../api';
import toast from 'react-hot-toast';
import { authHeader, getToken, saveAuth } from '../auth';

const Container = styled.div`
  max-width: 600px;
  margin: 0 auto;
  padding: 3rem 1rem;
  text-align: center;
`;

const IconWrapper = styled.div`
  display: inline-flex;
  width: 72px;
  height: 72px;
  border-radius: 999px;
  align-items: center;
  justify-content: center;
  background: #ecfdf3;
  color: #16a34a;
  margin-bottom: 1rem;
`;

const Title = styled.h1`
  font-size: 1.8rem;
  font-weight: 800;
  color: #111827;
  margin-bottom: 0.5rem;
`;

const Text = styled.p`
  font-size: 0.95rem;
  color: #4b5563;
  margin-bottom: 1rem;
`;

const Highlight = styled.div`
  margin-top: 1.5rem;
  padding: 1rem 1.25rem;
  border-radius: 12px;
  background: #f9fafb;
  text-align: left;
  font-size: 0.9rem;
  color: #374151;
`;

const Label = styled.span`
  font-weight: 600;
`;

const PaymentSuccess = () => {
  const [loading, setLoading] = useState(true);
  const [premiumInfo, setPremiumInfo] = useState(null);

  useEffect(() => {
    const fetchPremium = async () => {
      try {
        const res = await api.get('/api/user/premium', { headers: authHeader() });
        setPremiumInfo(res.data);

        const token = getToken();
        if (token) {
          const profileRes = await api.get('/api/auth/me', { headers: authHeader() });
          saveAuth(token, profileRes.data);
        }
      } catch (err) {
        const msg = err.response?.data?.error || 'Premium durumu okunamadı, lütfen giriş yaptığından emin ol.';
        toast.error(msg);
      } finally {
        setLoading(false);
      }
    };
    fetchPremium();
  }, []);

  const until = premiumInfo?.premium_until ? new Date(premiumInfo.premium_until) : null;

  return (
    <Container>
      <IconWrapper>
        {loading ? <Loader size={32} className="animate-spin" /> : <CheckCircle size={32} />}
      </IconWrapper>
      <Title>Ödeme Başarılı</Title>
      <Text>30 gün boyunca tüm araçlar sınırsız. Abonelik yok, otomatik yenileme yok.</Text>

      {premiumInfo && (
        <Highlight>
          <p>
            <Label>Premium durum:</Label>{' '}
            {premiumInfo.is_premium ? 'Aktif' : 'Pasif'}
          </p>
          {until && (
            <p>
              <Label>Premium bitiş tarihi:</Label>{' '}
              {until.toLocaleString()}
            </p>
          )}
        </Highlight>
      )}
    </Container>
  );
};

export default PaymentSuccess;
